import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
const useFieldError = () => {
    const $ = _c(3);
    const [fieldError, setFieldError] = useState(null);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (inError) => {
            if (!inError) {
                setFieldError(null);
            }
        };
        $[0] = t0;
    }
    else {
        t0 = $[0];
    }
    const setIsFieldInError = t0;
    let t1;
    if ($[1] !== fieldError) {
        t1 = [fieldError, setIsFieldInError, setFieldError];
        $[1] = fieldError;
        $[2] = t1;
    }
    else {
        t1 = $[2];
    }
    return t1;
};
export default useFieldError;
